"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class IpInvoiceStatus {
}
exports.IpInvoiceStatus = IpInvoiceStatus;
//# sourceMappingURL=IpInvoiceStatus.js.map